import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";

/** Endereço cadastrado no app da Meta. Precisa ser público e sem login. */
export const Route = createFileRoute("/termos")({
  component: Termos,
});

const CONTATO = "nelsijan.dev@gmail.com";

function Termos() {
  return (
    <LegalPage title="Termos de Uso" updatedAt="09/09/2026">
      <p>
        Estes termos valem para o sistema de atendimento e gestão comercial operado em{" "}
        <code>crm.nexusroas.com</code> pela clínica <strong>Dra. Fabi Libório</strong>.
      </p>

      <h2>O que o sistema faz</h2>
      <p>
        Reúne num só lugar os contatos que chegam por anúncios, comentários, Messenger, direct do
        Instagram e WhatsApp; organiza o atendimento e os agendamentos; e mede quais campanhas
        trazem pacientes.
      </p>

      <h2>Quem pode usar</h2>
      <p>
        O acesso é restrito à equipe autorizada da clínica, por conta individual. A senha é pessoal
        e intransferível — compartilhá-la torna quem a cedeu responsável pelo que for feito com ela.
        Suspeita de uso indevido deve ser comunicada imediatamente para {CONTATO}.
      </p>

      <h2>Uso aceitável</h2>
      <ul>
        <li>
          As mensagens automáticas só respondem a quem entrou em contato primeiro, e sobre o assunto
          do próprio contato
        </li>
        <li>
          É vedado usar o sistema para disparo em massa não solicitado, importar listas de contatos
          obtidas sem consentimento ou enviar conteúdo enganoso
        </li>
        <li>
          O uso precisa respeitar as regras das plataformas de origem (Meta e WhatsApp) e a
          legislação aplicável, incluindo a publicidade em saúde
        </li>
      </ul>

      <h2>Dados de pacientes e de contatos</h2>
      <p>
        A clínica é a controladora dos dados tratados no sistema e responde pelo uso que faz deles.
        O tratamento está descrito na{" "}
        <Link to="/privacidade" className="underline">
          Política de Privacidade
        </Link>
        .
      </p>

      <h2>Integrações com terceiros</h2>
      <p>
        O sistema se conecta a Facebook, Instagram e WhatsApp por credenciais que a própria clínica
        autoriza. Essas plataformas têm regras e limites próprios — por exemplo, a janela de 24
        horas para responder uma mensagem — e podem alterá-los ou suspender o acesso sem aviso.
        Indisponibilidade causada por elas está fora do controle do sistema.
      </p>

      <h2>Disponibilidade</h2>
      <p>
        O serviço é fornecido no estado em que se encontra, com esforço razoável de disponibilidade.
        Podem ocorrer interrupções para manutenção, correção e atualização.
      </p>

      <h2>Encerramento</h2>
      <p>
        A clínica pode encerrar o uso a qualquer momento e solicitar a exportação dos seus dados.
        Contas de pessoas que deixam a equipe devem ser desativadas imediatamente.
      </p>

      <h2>Alterações</h2>
      <p>
        Estes termos podem ser atualizados. A data de atualização no topo da página indica a versão
        vigente.
      </p>

      <h2>Contato</h2>
      <p>{CONTATO}</p>
    </LegalPage>
  );
}
